import React from "react";
import ContentContainer from "./contentContainer";
import { Box, Grid2 } from "@mui/material";
import PageTitle from "./pageTitle";
import { useReleaseNotes2 } from "../../fetch/fetchReleaseNotes";
import './g3ReleaseNotes.css';
import { useParams } from "react-router-dom";
import { PDFDownloadLink, PDFViewer, StyleSheet } from '@react-pdf/renderer';
import { ItemPdf } from "./g3ReleaseNotes";

const styles = StyleSheet.create({
    page: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    pageTitle: {
        marginBottom: 10,
        fontSize: '18pt',
        textAlign: 'left',
        borderBottom: '2px solid #c00'
    },
    pageTitleSubText: {
        fontSize: '12pt'
    },
    sectionTitle: {
        marginTop: 10,
        marginBottom: 10,
        marginHorizontal: 25,
        fontSize: 16,
        marginBottom: 10,
        borderBottom: '1px solid #000'
    },
    listItem: {
        flexDirection: 'row',
        marginBottom: 4,
        marginHorizontal: 30
    },
    bullet: {
        width: 10,
        fontSize: 12,
    },
    text: {
        fontSize: 12,
    },
});

export default function ReleaseNotesPdf() {
    const { versionParam } = useParams();
    const { items, isLoading } = useReleaseNotes2();

    let item = null;
    if (items && items.length > 0) {
        item = items.filter((item) => { return item.title === versionParam })[0];
    }

    return (
        <ContentContainer>
            <PageTitle title='Release Notes' />

            <Box component="main" sx={{ p: 3, width: '100%', paddingTop: 0 }}>
                <Grid2 container>
                    {!!item ? (
                        <>
                            <PDFDownloadLink document={<ItemPdf item={item} />} fileName={`${item.title.replace(' ', '_')}.pdf`}>
                                {({ blob, url, loading, error }) =>
                                    loading ? 'Loading document...' : 'Download now!'
                                }
                            </PDFDownloadLink>
                            <PDFViewer style={{ width: '100%', height: '500px' }}>
                                <ItemPdf item={item} />
                            </PDFViewer>
                        </>
                    ) : null}
                </Grid2>
            </Box>
        </ContentContainer>
    );
}